// Copyright (c) 2016 Deere & Company

import {errorAlertBar} from './alert-bar';
import moment from 'moment';
import {translate} from './translation-service';

const errorTypes = {
    401: 'ERROR_SESSION',
    502: 'SERVER_TOOK_TOO_LONG_TO_REPLY',
    504: 'SERVER_TOOK_TOO_LONG_TO_REPLY'
};

const getText = errorType => ({message: translate(errorType)});

const getJson = async response => {

    let reply;

    const responseText = await response.text();

    try {

        reply = JSON.parse(responseText);

    } catch (error) {

        // make sure response text is not ridiculously long

        const processedResponseText = responseText.length > 500 ? responseText.slice(0, 500) : responseText;

        reply = {isTranslated: true, message: processedResponseText};

    }

    return reply;

};

export const handleError = async response => {

    let reply;

    if (typeof response.status === 'undefined') {

        reply = response;

    } else if (response.status === 553) {

        reply = response;

    } else {

        const errorType = errorTypes[response.status];

        reply = errorType ?
            await getText(errorType) :
            await getJson(response);

        errorAlertBar(reply);

    }

    return Promise.reject(reply);

};

export const handleNoSapAccess = async (response, user, service) => {

    const statusCode = response.status;
    const timestamp = moment().valueOf();

    let message,
        reference;

    try {

        const responseContent = await response.json();

        reference = responseContent.reference;
        message = responseContent.message;

    } catch (err) {

        reference = 'no reference';
        message = 'no message';

    }

    window.location = `./NO_SAP_ACCESS.html?statusCode=${statusCode}&reference=${reference}&message=${message}&timestamp=${timestamp}&user=${user}&service=${service}`;

};



// WEBPACK FOOTER //
// ./src/shared/services/error-handlers.js